import {
  REDUX_CLEAR_NETWORK_ERROR,
  REDUX_SET_CONNECTIVITY_STATUS,
  REDUX_SET_NETWORK_ERROR,
} from './ActionTypes/ReduxActionTypes'

export const setConnectivityStatus = (isOnline) => ({
  type: REDUX_SET_CONNECTIVITY_STATUS,
  payload: {isOnline},
})

export const setNetworkError = (message) => ({
  type: REDUX_SET_NETWORK_ERROR,
  payload: {message},
})

export const clearNetworkError = () => ({
  type: REDUX_CLEAR_NETWORK_ERROR,
})
